import { putPastedExternalContent } from "./putPastedContent.mjs";
async function pasteUrl(editor, url, point, sources, clipboardPasteSource = "native-event") {
  editor.markHistoryStoppingPoint("paste");
  return await putPastedExternalContent(
    editor,
    {
      type: "url",
      point,
      url,
      sources
    },
    { source: clipboardPasteSource, point }
  );
}
export {
  pasteUrl
};
//# sourceMappingURL=pasteUrl.mjs.map
